(() => {
    // Update Cart Item counter
    const getCart = async () => {
        const result = await fetch("/cart.json");
    
        if (result.status === 200) {
            const cart = result.json();
            return cart;
        };
        throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
    };
    window.cart_counter = async () => {
        getCart().then(res => {
            const { item_count } = res;
            const counter = document.querySelector('[data-cart-count]');
            const counterADA = document.querySelector('[data-cart-count-ada]');
            
            if(counter) counter.textContent = item_count;
            if(counterADA) counterADA.textContent = `${item_count} items`;
        });
    };

    // Listener for hiding cart with keyboard
    const handleKeyUp = (e) => {
        const smartCart = document.querySelector("#rebuy-cart");
        if(e.key === "Escape" && smartCart?.classList.contains("is-visible")){
            const close = smartCart.querySelector(".rebuy-cart__flyout-close");
            close?.click();
        };
    };
    document.addEventListener("keyup", e => handleKeyUp(e));
})();